export default "__VITE_ASSET__DOBSd2Yf__"